module.exports = __webpack_public_path__ + "media/images/emblems/Yvonand-coat_of_arms-5611984d56b03d59eaca8fc183e91c47.svg";